import { Injectable } from '@angular/core';
import {
  BULKSHIPMENTCART,
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  STOCKCART,
  MOVESTOCKLOCATION, MOVESTOCKCART
} from '../providers/data';
import { CartPage } from '../pages/cart/cart';
import { Headers, RequestOptions } from '@angular/http';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
import { CustomerCarts } from './user-cart-provider/user-carts';
@Injectable()
export class BulkshipmentcartManager {



  public getCust:any ;
  constructor(private storage:Storage,private sanitizer:DomSanitizer){

  }


  getProductsCount(){
    return BULKSHIPMENTCART.shipments.length;
  }

  getSalesManId(){
    return BULKSHIPMENTCART.user.id;
  }

  getADPCustomerUUID(){
    if(BULKSHIPMENTCART.user && BULKSHIPMENTCART.user.adpCustomerInfo){
      return BULKSHIPMENTCART.user.adpCustomerInfo.uuid;
    }else{
      return "";
    }
  }


  makeImageURL(dimensions,item){
    console.log("Product images url " + IMAGES_BASE_URL.imageBaseUrl + this.getSupplierUuid() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension);
    // return  IMAGES_BASE_URL + this.getADPCustomerUUID() +
    //   "/products/" +
    //   dimensions + "/"+
    //   item.productImagesDTO[0].name+
    //   "-" +
    //   dimensions +
    //   "." +
    //   item.productImagesDTO[0].extension;

    return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getSupplierUuid() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension;
  }

  getSupplierUuid() {
    return AdpCustomer.AdpCustomerInfo.uuid;
  }

  persistOrderLocal(){

    if(Number(BULKSHIPMENTCART.shipments.length) > 0){
      this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),BULKSHIPMENTCART);

    }else{
      this.unPersistOrderLocal();
    }
  }
  unPersistOrderLocal(){
    this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  }

  deleteProductFromCart(product){
    var index= BULKSHIPMENTCART.shipments.map(function(x) {return x.shipmentNoticeByNoticesId.referenceNo; }).indexOf(product.shipmentNoticeByNoticesId.referenceNo);
    if (index != -1) {
      this.removeNew(index);
    }
  }
  removeNew(index: number): void {

    BULKSHIPMENTCART.shipments.splice(index, 1);
    this.persistOrderLocal();
  }

  getItems(){
    return BULKSHIPMENTCART.shipments;
  }

  getAdpCustomerInfo(){
    return AdpCustomer.AdpCustomerInfo;
  }

  clearCart(){
    console.log("dddddddddd" + BULKSHIPMENTCART.shipments)

    for(let product of BULKSHIPMENTCART.shipments){
      this.removeAll(product);
    }

    BULKSHIPMENTCART.shipments = [];
    // this.persistOrderLocal();
    // console.log("dddddddddd" + BULKSHIPMENTCART.shipments)
  }

  removeAll(product) {
    var index= BULKSHIPMENTCART.shipments.map(function(x) {return x.shipmentNoticeByNoticesId.referenceNo; }).indexOf(product.shipmentNoticeByNoticesId.referenceNo);
    if (index != -1) {
      this.removeNew(index);
    }
    this.persistOrderLocal();
  }


  addToCartNew(product) {
    // BULKSHIPMENTCART.shipments.unshift(product);
    BULKSHIPMENTCART.shipments.push(product);
    this.persistOrderLocal();
  }

  addOrderAgainstShipment(order, ship){
    for (let shipments of BULKSHIPMENTCART.shipments) {
      // this.gVLogger.log("shipments for loop in shipments + " + JSON.stringify(shipments.shipmentNoticeByNoticesId.shipmentNo))

      if (shipments.shipmentNoticeByNoticesId.referenceNo === ship.shipmentNoticeByNoticesId.referenceNo) {
        shipments.order = order;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/bulkshipmentcart-manager.ts